<template>
  <layout-default :hide-footer-mobile="true">
    <steps-header
      :current-step="3"
      extra-class="steps-component-payment-page"
    ></steps-header>

    <div
      class="step-3-content"
      data-aos="fade-left"
      data-aos-duration="1500"
      data-aos-once="true"
    >
      <div class="pdv-container">
        <div class="custom-padding">
          <div class="row">
            <div class="col">
              <h3 class="section-title">Revisa y confirma tus cursos</h3>
            </div>
          </div>
          <div class="row" id="affixContainer">
            <div class="col-md-6 col-xs-12">
              <div class="check-in-info">
                <div
                  v-for="(student, index) in students"
                  :key="index"
                  class="check-in-info-card"
                >
                  <span v-if="students.length > 1" class="number-student-tag"
                    >ESTUDIANTE {{ index + 1 }}</span
                  >

                  <div class="main-info">
                    <div class="item">
                      <span class="item-head">Programa</span>
                      <span class="item-value">
                        {{ student.program.name }}
                      </span>
                    </div>
                    <div class="item">
                      <span class="item-head">Nombre del estudiante</span>
                      <span class="item-value">{{
                        student.name + " " + student.fatherLastName
                      }}</span>
                    </div>

                    <div v-if="!selectedProgram.isOnline" class="item">
                      <span class="item-head">Sede</span>
                      <span class="item-value"
                        >{{ student.selectedLocation.address }} *</span
                      >
                    </div>

                    <div class="heading-info">
                      <span>Cursos</span>
                    </div>

                    <div
                      v-if="selectedProgram.isOnline"
                      class="item"
                      v-for="(course, index) in student.selectedCourses"
                      :key="index"
                    >
                      <span class="item-head"
                        >{{ course.Subject.name }} {{ course.pdvCode }}</span
                      >
                      <span class="item-value">
                        <span v-if="course.hour">{{
                          getSchedule(course.hoursPerDay)
                        }}</span>
                      </span>
                    </div>

                    <div
                      v-if="!selectedProgram.isOnline"
                      class="item"
                      v-for="(course, index) in student.selectedCourses"
                      :key="index"
                    >
                      <span class="item-head"
                        >{{ course.subjectName }}
                        {{ course.coursePdvCode }}</span
                      >
                      <span class="item-value">
                        <span v-if="course.hour">{{
                          getSchedule(course.hoursPerDay)
                        }}</span>
                      </span>
                    </div>
                  </div>
                  <div class="price-info">
                    <div class="header">
                      <span class="key">Precio Bruto</span>
                      <span v-if="student.prices" class="value">
                        {{ student.prices.precioBruto | moneyFormatter }}
                      </span>
                    </div>
                    <div class="amounts">
                      <div class="amount-item promo-info-item">
                        <span v-if="student.prices" class="value key"
                          >Descuento por sesiones ({{
                            round(
                              student.prices.valorDescuentoSesiones /
                                student.prices.precioBruto
                            )
                          }}%)</span
                        >
                        <span v-if="student.prices" class="value"
                          >-
                          {{
                            student.prices.valorDescuentoSesiones
                              | moneyFormatter
                          }}
                        </span>
                      </div>
                    </div>

                    <div class="header">
                      <span class="key">Total cursos</span>
                      <span v-if="student.prices" class="value">
                        {{ student.prices.precioSubTotal | moneyFormatter }}
                      </span>
                    </div>
                    <div class="amounts">
                      <div class="amount-item"></div>
                      <div class="amount-item promo-info-item">
                        <span class="key"
                          >Desc. inscripción online ({{ discount }}%)
                        </span>
                        <span v-if="student.prices" class="value"
                          >-
                          {{ student.prices.valorDescuento | moneyFormatter }}
                        </span>
                      </div>
                      <div class="amount-item">
                        <span class="key">Matrícula online</span>
                        <span v-if="student.prices" class="value">{{
                          student.prices.valorMatricula | moneyFormatter
                        }}</span>
                      </div>
                      <div class="amount-discounts">
                        <div class="amount-item">
                          <span class="key">Total descuento</span>
                          <span v-if="student.prices" class="value">
                            {{
                              (student.prices.valorDescuentoSesiones +
                                student.prices.valorDescuento)
                                | moneyFormatter
                            }}
                          </span>
                        </div>
                        <div class="amount-item">
                          <span class="key"
                            >Porcentaje total de descuento aplicado</span
                          >
                          <span v-if="student.prices" class="value">
                            {{
                              round(
                                (student.prices.valorDescuentoSesiones +
                                  student.prices.valorDescuento) /
                                  student.prices.precioBruto
                              )
                            }}
                            %
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="coupon-info" v-if="coupon">
                    <div class="amounts">
                      <div class="amount-item promo-info-item">
                        <span class="key">Cupón Aplicado</span>
                        <span class="value"
                          >Cupón ({{ getPercentaje() }}%)</span
                        >
                      </div>
                      <div class="amount-item promo-info-item">
                        <span class="key">Descuento Cupón</span>
                        <span class="value"
                          >- {{ valueCoupon | moneyFormatter }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="final-price-info">
                    <span class="key">Monto Programa</span>
                    <span v-if="student.prices" class="value"
                      >{{ student.prices.precioTotal | moneyFormatter }} **
                    </span>
                  </div>
                </div>

                <a
                  v-if="false"
                  href="#"
                  @click.prevent="addOtherStudent"
                  class="d-md-none underline-link underline-link--secondary"
                  >+ AGREGAR OTRO ESTUDIANTE</a
                >
              </div>

              <!-- <div class="note w-full d-flex">
                <div>
                  <img src="/images/featured/warning.svg" alt="warning" />
                </div>
                <div class="flex-1">
                  <div class="title-note">IMPORTANTE</div>
                  <p class="text-note">
                    * La dirección de la sede "Avda. Apoquindo 5142, Las Condes"
                    <b>aparecerá por defecto</b> al seleccionar programas PDVx o
                    PDV Online.
                  </p>
                  <p class="text-note">
                    ** El monto obtenido en tu cotización corresponde al
                    <b>valor anual</b> de tu programa
                  </p>
                </div>
              </div> -->
            </div>

            <div class="col-md-6 col-xs-12 position-relative d-md-block">
              <affix
                relative-element-selector="#affixContainer"
                class="only-desktopBlock"
              >
                <div v-if="total != null || total != undefined">
                  <abstract-check-in-info
                    @buttonClicked="saveOrderData"
                    @apllyCouponClicked="appllyCoupon"
                    @addCouponClicked="addCoupon"
                    @removeCoupon="removeCoupon"
                    :total="total"
                    :subTotal="subTotal"
                    :validCoupon="validCoupon"
                    :valorDescuentoCupon="valueCoupon"
                    :valorDescuento="valorDescuentoApi"
                    :precioSubTotal="precioSubTotalApi"
                  ></abstract-check-in-info>
                  <a
                    v-if="false"
                    href="#"
                    @click.prevent="addOtherStudent"
                    class="underline-link underline-link--secondary"
                    >+ AGREGAR OTRO ESTUDIANTE</a
                  >
                </div>
                <div v-else>
                  {{ " " }}
                </div>
              </affix>

              <div class="only-mobileBlock margen-custom-total">
                <div v-if="total != null || total != undefined">
                  <abstract-check-in-info
                    @buttonClicked="saveOrderData"
                    @apllyCouponClicked="appllyCoupon"
                    @addCouponClicked="addCoupon"
                    @removeCoupon="removeCoupon"
                    :total="total"
                    :subTotal="subTotal"
                    :validCoupon="validCoupon"
                    :valorDescuentoCupon="valueCoupon"
                    :valorDescuento="valorDescuentoApi"
                    :precioSubTotal="precioSubTotalApi"
                  ></abstract-check-in-info>
                  <a
                    v-if="false"
                    href="#"
                    @click.prevent="addOtherStudent"
                    class="underline-link underline-link--secondary"
                    >+ AGREGAR OTRO ESTUDIANTE</a
                  >
                </div>
                <div v-else>
                  {{ " " }}
                </div>
              </div>
            </div>
            <div class="note w-full d-flex mb-2">
                <div>
                  <img
                    src="/images/featured/warning.svg"
                    alt="warning"
                  />
                </div>
                <div class="flex-1">
                  <div class="title-note">
                    IMPORTANTE
                  </div>
                  <p class="text-note">
                    * La dirección de la sede "Avda. Apoquindo 5142, Las Condes" <b>aparecerá por defecto</b> al seleccionar programas PDVx o PDV Online.
                  </p>
                  <p class="text-note">
                    ** El monto obtenido en tu cotización corresponde al <b>valor anual</b> de tu programa
                  </p>
                </div>
              </div>
            <a
              style="visibility: hidden"
              ref="btnUnknowErrorModal"
              data-backdrop="static"
              data-keyboard="false"
              href=".unknow-error-modal"
              data-toggle="modal"
            ></a>
          </div>
        </div>
      </div>

      <unknow-error-modal />
    </div>
  </layout-default>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";
import LayoutDefault from "@/layouts/Default";
import StepsHeader from "@/components/StepsHeader";
import AbstractCheckInInfo from "@/components/AbstractCheckInInfo";
import UnknowErrorModal from "@/components/modals/UnknowErrorModal";

export default {
  data() {
    return {
      interval: null,
      total: null,
      discount: null,
      coupon: null,
      valueCoupon: 0,
      subTotal: 0,
      validCoupon: true,
      totalResponseApi: 1000,
      validCouponResponseAPi: false,
      valorDescuentoApi: 0,
      precioSubTotalApi: 0,
      rut: "",
    };
  },

  computed: {
    programSelectedTitle() {
      return "PSU " + this.$store.state.student.program;
    },
    selectedProgram() {
      return this.$store.state.selectedProgram;
    },
    selectedSubjects() {
      return this.$store.state.selectedSubjects;
    },
    selectedSubjectsWithCourses() {
      return this.$store.state.selectedSubjectsWithCourses;
    },
    ...mapState(["students", "quotasTimeRemaining"]),
  },

  components: {
    LayoutDefault,
    StepsHeader,
    AbstractCheckInInfo,
    UnknowErrorModal,
  },

  methods: {
    ...mapActions(["setQuotasTimeRemaining", "clearCoursesNotAvailables"]),

    round(num, decimalPlaces = 2) {
      let newNum = num * 100;
      return Math.round(newNum);
    },

    discountSeconds() {
      const currentTime = moment(this.quotasTimeRemaining, "mm:ss").subtract(
        1,
        "second"
      );
      this.setQuotasTimeRemaining(currentTime.format("mm:ss"));
    },
    getPercentaje() {
      if (this.subTotal === 0) {
        return 0;
      } else {
        return Math.round(((this.subTotal - this.total) * 100) / this.subTotal);
      }
    },
    loadCourseQuote(cupon) {
      let orderId;
      if (localStorage.ordenID) {
        orderId = localStorage.ordenID;
      }
      let promesas = [];
      this.students.forEach((student) => {
        promesas.push(
          new Promise((resolve) => {
            let locationId = student.selectedLocation.id;
            let programId = student.program.id;
            let coursesIds;
            if (this.selectedProgram.isOnline) {
              coursesIds = this.selectedSubjectsWithCourses.map(
                (sub) => sub.courses[0].id
              );
            } else {
              coursesIds = student.selectedCourses
                .map((course) => course.courseId)
                .join(",");
            }
            this.rut = this.students[0].rut.replaceAll(".", "");
            let url = `/quote?locationId=${locationId}&programId=${programId}&coursesIds=${coursesIds}&studentId=${student.id}&orderId=${orderId}`;
            if (cupon) {
              url += `&coupon=${cupon}&rut=${this.rut}`;
            }
            this.Axios.get(url)
              .then((response) => {
                let info = {
                  student,
                  append: { prices: response.data },
                };
                this.totalResponseApi = response.data.precioTotal;
                this.validCouponResponseAPi = response.data.validCupon;
                this.precioSubTotalApi = response.data.precioSubTotal;
                this.valorDescuentoApi = response.data.valorDescuento;
                if (cupon) {
                  this.validCoupon = response.data.validCupon;
                }
                if (response.data.validCupon) {
                  this.coupon = cupon;
                  this.valueCoupon = response.data.valorDescuentoCupon;
                } else {
                  this.coupon = null;
                  this.valueCoupon = 0;
                }
                if (this.subTotal === 0) {
                  this.subTotal = response.data.precioTotal;
                }
                //falta validar si cupon es valid
                this.$store.dispatch("addInfoToStudent", info);
                resolve();
              })
              .catch((err) => {
                if (err.response.data.name === "QuoteFailed") {
                  this.$refs.btnUnknowErrorModal.click();
                }
              });
          })
        );
      });
      try {
        Promise.all(promesas).then(() => {
          this.setTotal();
          this.$store.dispatch("setStudentsWithPrices");
        });
      } catch (err) {
        alert("ji");
      }
    },
    getSchedule(hoursPerDay) {
      let days = "";
      if (hoursPerDay.length == 1) {
        days =
          hoursPerDay[0].day +
          " " +
          hoursPerDay[0].startTime.slice(0, -3) +
          " a " +
          hoursPerDay[0].endTime.slice(0, -3);
      } else if (hoursPerDay.length == 2) {
        if (
          hoursPerDay[0].startTime.slice(0, -3) ==
            hoursPerDay[1].startTime.slice(0, -3) &&
          hoursPerDay[0].endTime.slice(0, -3) ==
            hoursPerDay[1].endTime.slice(0, -3)
        ) {
          days =
            hoursPerDay[0].day +
            " y " +
            hoursPerDay[1].day +
            " " +
            hoursPerDay[0].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[0].endTime.slice(0, -3);
        } else {
          days =
            hoursPerDay[0].day +
            " " +
            hoursPerDay[0].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[0].endTime.slice(0, -3) +
            " y " +
            hoursPerDay[1].day +
            " " +
            hoursPerDay[1].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[1].endTime.slice(0, -3);
        }
      } else if (hoursPerDay.length == 3) {
        if (
          hoursPerDay[0].startTime.slice(0, -3) ==
            hoursPerDay[1].startTime.slice(0, -3) &&
          hoursPerDay[0].endTime.slice(0, -3) ==
            hoursPerDay[1].endTime.slice(0, -3) &&
          hoursPerDay[0].startTime.slice(0, -3) !=
            hoursPerDay[2].startTime.slice(0, -3)
        ) {
          days =
            hoursPerDay[0].day +
            " y " +
            hoursPerDay[1].day +
            " " +
            hoursPerDay[0].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[0].endTime.slice(0, -3) +
            " y " +
            hoursPerDay[2].day +
            " " +
            hoursPerDay[2].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[2].endTime.slice(0, -3);
        } else if (
          hoursPerDay[0].startTime.slice(0, -3) ==
            hoursPerDay[2].startTime.slice(0, -3) &&
          hoursPerDay[0].endTime.slice(0, -3) ==
            hoursPerDay[2].endTime.slice(0, -3) &&
          hoursPerDay[0].startTime.slice(0, -3) !=
            hoursPerDay[1].startTime.slice(0, -3)
        ) {
          days =
            hoursPerDay[0].day +
            " y " +
            hoursPerDay[2].day +
            " " +
            hoursPerDay[0].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[0].endTime.slice(0, -3) +
            " y " +
            hoursPerDay[1].day +
            " " +
            hoursPerDay[1].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[1].endTime.slice(0, -3);
        } else if (
          hoursPerDay[2].startTime.slice(0, -3) ==
            hoursPerDay[1].startTime.slice(0, -3) &&
          hoursPerDay[2].endTime.slice(0, -3) ==
            hoursPerDay[1].endTime.slice(0, -3) &&
          hoursPerDay[0].startTime.slice(0, -3) !=
            hoursPerDay[2].startTime.slice(0, -3)
        ) {
          days =
            hoursPerDay[2].day +
            " y " +
            hoursPerDay[1].day +
            " " +
            hoursPerDay[2].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[2].endTime.slice(0, -3) +
            " y " +
            hoursPerDay[0].day +
            " " +
            hoursPerDay[0].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[0].endTime.slice(0, -3);
        } else if (
          hoursPerDay[0].startTime.slice(0, -3) ==
            hoursPerDay[1].startTime.slice(0, -3) &&
          hoursPerDay[0].endTime.slice(0, -3) ==
            hoursPerDay[1].endTime.slice(0, -3) &&
          hoursPerDay[0].startTime.slice(0, -3) ==
            hoursPerDay[2].startTime.slice(0, -3) &&
          hoursPerDay[0].endTime.slice(0, -3) ==
            hoursPerDay[2].endTime.slice(0, -3)
        ) {
          days =
            hoursPerDay[0].day +
            ", " +
            hoursPerDay[1].day +
            " y " +
            hoursPerDay[2].day +
            " " +
            hoursPerDay[0].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[0].endTime.slice(0, -3);
        } else {
          days =
            hoursPerDay[0].day +
            " " +
            hoursPerDay[0].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[0].endTime.slice(0, -3) +
            ", " +
            hoursPerDay[1].day +
            " " +
            hoursPerDay[1].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[1].endTime.slice(0, -3) +
            " y " +
            hoursPerDay[2].day +
            " " +
            hoursPerDay[2].startTime.slice(0, -3) +
            " a " +
            hoursPerDay[2].endTime.slice(0, -3);
        }
      }
      return days;
    },
    async saveOrderData() {
      let fullOrderStudentsData = this.students.map((student) => {
        let coursesIds;
        if (this.selectedProgram.isOnline) {
          this.$store.dispatch("clearSelectedCourses");
          let course = this.selectedSubjectsWithCourses.map(
            (sub) => sub.courses[0]
          );
          course.forEach((c) => {
            this.$store.dispatch("saveCourseSelected", c);
          });
          coursesIds = course.map((c) => c.id);
        } else {
          coursesIds = student.selectedCourses.map((course) => course.courseId);
        }
        return {
          locationId: student.selectedLocation.id,
          programId: student.program.id,
          coursesIds,
          studentId: student.id,
        };
      });
      await this.$store.dispatch("addInfoToFullOrder", {
        orderDetails: fullOrderStudentsData,
        coupon: this.coupon,
        rut: this.rut,
      });
      this.goToNextStep();
    },
    async appllyCoupon(coupon) {
      this.loadCourseQuote(coupon);
    },
    addCoupon() {
      this.validCoupon = true;
    },
    setTotal() {
      if (this.validCouponResponseAPi && this.totalResponseApi === 0) {
        this.total = this.totalResponseApi;
      } else {
        this.total = this.$store.state.students
          .map((student) => student.prices.precioTotal)
          .reduce(
            (previousValue, currentValue) => previousValue + currentValue
          );
      }
    },

    goToNextStep() {
      this.$router.push({ name: "Step4" });
    },
    addOtherStudent() {
      this.$store.dispatch("showBackpack").then(() => {
        this.$router.push({ name: "BuyOtherProgram" });
      });
    },
    removeCoupon() {
      this.coupon = null;
      this.valueCoupon = 0;
      this.validCoupon = true;
      this.loadCourseQuote(null);
    },
  },

  async mounted() {
    this.interval = setInterval(this.discountSeconds, 1000);
    this.loadCourseQuote(null);
    if (this.selectedProgram.isOnline) {
      this.$store.dispatch("clearSelectedCourses");
      let course = this.selectedSubjectsWithCourses.map(
        (sub) => sub.courses[0]
      );
      course.forEach((c) => {
        this.$store.dispatch("saveCourseSelected", c);
      });
    }
    const sessionState = {
      students: this.students,
    };
    let newSesionState = [];
    let newSubject = [];

    sessionState.students.forEach((fila) => {
      fila.selectedSubjects.forEach((subject) => {
        newSubject.push({
          checked: true,
          color: subject.color,
          disabled: subject.disabled,
          displayName: subject.displayName,
          hasMention: subject.hasMention,
          iconSrc: subject.iconSrc,
          id: subject.id,
          mes: subject.mes,
          name: subject.name,
          subject: subject.subject,
          courses: [],
        });
      });
      newSesionState.push({
        ...fila,
        selectedSubjects: newSubject,
      });
    });
    const copySesion = {
      students: newSesionState,
    };

    this.$store.dispatch("clearSelectedSubjects").then(() => {
      newSubject.forEach((s) => {
        this.$store.dispatch("addSubject", s);
      });
    });

    await this.$store.dispatch("clearCoursesNotAvailables");
    await this.$store.dispatch("addInfoToFullOrder", {
      // sessionState: JSON.stringify(sessionState)
      sessionState: JSON.stringify(copySesion),
    });
    await this.Axios.put(
      "/orders",
      { ...this.$store.state.fullOrder, financingParty: null },
      { withCredentials: true }
    );
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  filters: {
    timeRemaining(time) {
      return moment(time, "mm:ss").format("mm’ ss’’");
    },
  },

  created() {
    this.Axios.get("/dashadmin/infogeneral").then((response) => {
      this.discount = response.data[0].discount;
    });
  },
};
</script>

<style scoped lang="scss">
.margen-custom-total {
  @media (max-width: 768px) {
    margin-top: 40px;
    margin-right: -24px !important;
    margin-left: -24px !important;
  }
}

.boton-new-primario {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background-color: $morado50;
  border: solid 4px $neutralwhite;
  color: $neutralwhite;
  &:hover {
    background-color: $morado30;
  }
  &:active {
    background-color: $morado90;
  }
  &:focus {
    background-color: $morado50;
    border: solid 4px grey;
  }
  &:disabled {
    background-color: #5924661a;
  }

  &.boton-new-largo {
    padding: 0 32px;
    height: 60px;
    width: auto;
    font-size: 20px;
    line-height: 28px;
  }
  &.boton-new-mediano {
    padding: 0 24px;
    height: 48px;
    width: auto;
    font-size: 16px;
    line-height: 18px;
  }
  &.boton-new-pequeno {
    padding: 0 16px;
    height: 32px;
    width: auto;
    font-size: 14px;
    line-height: 22px;
  }

  img {
    margin-right: 16px;
  }
}

.seccion-separator {
  width: 100%;
  @media (max-width: 768px) {
    margin-top: 32px;
  }
  @media (min-width: 769px) {
    margin-top: 40px;
  }
}

.imagen-pensar {
  @media (min-width: 769px) {
    margin-top: -170px;
  }
}

.w-accordion-custom {
  @media (max-width: 768px) {
    width: 100%;
  }
  @media (min-width: 769px) {
    width: 352px;
  }
}

.custom-padding {
  @media (max-width: 768px) {
    padding: 0 24px;
  }
  @media (min-width: 769px) {
    padding: 0 76px;
  }
}

.step-3-content {
  @media (min-width: 769px) {
    padding-bottom: 48px;
  }

  .section-title {
    color: $neutralBlack;
    font-family: "Poppins-Bold", sans-serif;
    font-style: normal;
    @media (max-width: 768px) {
      font-size: 20px;
      line-height: 28px;
    }
    @media (min-width: 769px) {
      font-size: 32px;
      line-height: 42px;
    }
  }

  .vue-affix {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  h3 {
    font-size: 18px;
    line-height: 26px;
    @include alternative-regular;
    margin-bottom: 15px;
    @include media-breakpoint-down(sm) {
      margin-top: 20px;
    }
  }
}

div .underline-link {
  margin-left: 105px;
}

.alert-info {
  display: flex;
  align-items: center;
  background: $red-2;
  padding: 5px 25px;
  position: absolute;
  top: -45px;
  right: 15px;

  img {
    width: 25px;
    @include media-breakpoint-down(sm) {
      width: 22px;
    }
  }

  p {
    color: #fff;
    margin-bottom: 0;
    font-size: 14px;
    @include alternative-light-regular;
    margin: 0 5px;
  }

  span {
    color: #fff;
    font-size: 20px;
    @include alternative-medium-regular;
    @include media-breakpoint-down(sm) {
      font-size: 18px;
    }
  }

  @include media-breakpoint-down(sm) {
    width: calc(100% + 30px);
    position: static;
    right: unset;
    top: unset;
    margin-left: -15px;
    margin-right: -15px;
    justify-content: center;
    padding: 5px 4px;
  }
}

.check-in-info {
  .check-in-info-card {
    border-radius: 8px;
    border: 1px solid $neutralBlack;
    padding: 16px;
    margin-bottom: 30px;

    .number-student-tag {
      letter-spacing: 2px;
      font-size: 12px;
      line-height: 22px;
      margin-bottom: 22px;
      @include alternative-regular;
      color: $gray;
      display: inline-block;
    }

    ul {
      padding-left: 0;
      margin-bottom: 0;

      li {
        display: flex;
        justify-content: space-between;
        list-style: none;
        margin-bottom: 16px;

        &:last-child {
          margin-bottom: 0;
        }

        span {
          font-size: 14px;
          @include alternative-light-regular;

          .index-number {
            font-size: 16px;
            @include alternative-medium-regular;
          }

          &:last-child {
            text-align: right;
          }
        }

        &.heading-info {
          span {
            color: $neutral70;
            font-family: Poppins;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: 22px;
          }
        }

        &.promo-info-item {
          span {
            @include media-breakpoint-down(sm) {
              font-size: 12px;
            }
            color: $green;
            font-size: 16px;
            line-height: 5px;
            @include alternative-medium-regular;
          }
        }
      }
    }

    .heading-info {
      span {
        color: $neutral70;
        font-family: "Poppins-Bold", sans-serif;
        font-size: 14px;
        font-style: normal;
        line-height: 22px;
      }
    }

    .main-info {
      padding-bottom: 30px;
      margin-bottom: 16px;
      border-bottom: 2px dashed #cacbce;

      .item {
        display: flex;
        flex-direction: column;
        margin-bottom: 12px;

        .item-head {
          color: $neutral70;
          font-family: "Poppins-Regular", sans-serif;
          font-size: 14px;
          font-style: normal;
          line-height: 22px;
        }

        .item-value {
          color: $neutralBlack;
          font-family: "Poppins-Medium", sans-serif;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: 24px;

          span {
            color: $neutralBlack;
            font-family: "Poppins-Medium", sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 24px;
          }
        }
      }

      .info-item {
        margin-bottom: 10px;
      }
      .info-item > span:last-child {
        @include alternative-regular;
        color: #000;
      }
    }

    .price-info {
      padding-bottom: 24px;
      margin-bottom: 24px;
      border-bottom: 1px solid $neutral10;

      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .key {
          color: $neutralBlack;
          font-family: "Poppins-Regular", sans-serif;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px;
        }

        .value {
          color: $neutral70;
          text-align: right;
          font-family: "Poppins-Medium", sans-serif;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 22px;
        }
      }

      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .amounts {
        .amount-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;

          .key {
            color: $succes80;
            font-family: "Poppins-Regular", sans-serif;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px;
          }

          .value {
            color: $succes80;
            font-family: "Poppins-Medium", sans-serif;
            font-size: 12px;
            font-style: normal;
            line-height: 16px;
          }
        }
      }
    }

    .coupon-info {
      padding-bottom: 16px;
      margin-bottom: 16px;
      border-bottom: 0.5px solid $gray;

      .amounts {
        .amount-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;

          .key {
            color: $succes80;
            font-family: "Poppins-Regular", sans-serif;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px;
          }

          .value {
            color: $succes80;
            font-family: "Poppins-Medium", sans-serif;
            font-size: 12px;
            font-style: normal;
            line-height: 16px;
          }
        }
      }
    }

    .amount-discounts {
      padding-top: 1rem;
      border-top: 2px dashed #cacbce;
    }

    .final-price-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .key {
        color: $neutralBlack;
        font-family: "Poppins-Regular", sans-serif;
        @media (max-width: 768px) {
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px;
        }
        @media (min-width: 769px) {
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px;
        }
      }
      .value {
        color: $neutral70;
        font-family: "Poppins-Bold", sans-serif;
        text-align: right;
        @media (max-width: 768px) {
          font-size: 20px;
          font-style: normal;
          font-weight: 700;
          line-height: 28px;
        }
        @media (min-width: 769px) {
          font-size: 16px;
          font-style: normal;
          font-weight: 700;
          line-height: 24px;
        }
      }
    }
  }
}

.note {
  border-radius: 8px;
  border: 1px solid #f1c469;
  background: #fffaf0;
  box-sizing: border-box;
  padding: 12px 16px;
  margin-top: 25px;
  img {
    margin-right: 12px;
  }
}

.note-mobile {
  display: none;
  border-radius: 8px;
  border: 1px solid #f1c469;
  background: #fffaf0;
  box-sizing: border-box;
  padding: 20px;
  @include alternative-regular;
  width: 100%;
  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
}

.title-note {
  color: #966a11;
  font-family: "Poppins-Medium", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.text-note {
  color: #966a11;
  font-family: "Poppins-Regular", sans-serif;
  font-size: 14px;
  font-style: normal;
  line-height: 22px;

  span {
    font-family: "Poppins-Bold", sans-serif;
  }
}

.vue-affix {
  flex-direction: column !important;
  align-items: flex-end !important;
}
</style>
